import { render } from "./NewsLetter.vue?vue&type=template&id=52c8c961"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"

import "./NewsLetter.vue?vue&type=style&index=0&id=52c8c961&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__